import { Button } from 'Components/Buttons/Buttons';
import { Role } from 'Components/Context/RBACContext';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE } from 'Config/Icons';

/** Typed as a `Record` so that adding a `Role` without a description is a compile error. */
const ROLE_DESCRIPTIONS: Record<Role, string> = {
    [Role.ADMIN]: 'Grants access to all features, including company-wide settings and user management.',
    [Role.CONTROL_USER]: 'Grants access to the "Control Automation" module.',
    [Role.CONTROL_USER_READ_ONLY]: 'Grants read-only access to the "Control Automation" module.',
    [Role.REPORTING_USER]: 'Grants access to the "Reporting and Exports" module.',
    [Role.RISK_MANAGER]: 'Grants access to the "Risk Management" module, including the "Risk Review" feature.',
    [Role.RISK_MANAGER_READ_ONLY]: 'Grants read-only access to the "Risk Management" module, including the "Risk Review" feature.',
    [Role.RISK_USER]: 'Grants access to the "Risk Management" module, excluding the "Risk Review" feature.',
    [Role.RISK_USER_READ_ONLY]: 'Grants read-only access to the "Risk Management" module, excluding the "Risk Review" feature.',
    [Role.THIRD_PARTY_USER]: 'Grants access to the "Third-Party Risk Management" module.',
    [Role.THIRD_PARTY_USER_READ_ONLY]: 'Grants read-only access to the "Third-Party Risk Management" module.',
    [Role.UCRM_USER]: 'Grants access to the "AI Governance" module.',
    [Role.UCRM_USER_READ_ONLY]: 'Grants read-only access to the "AI Governance" module.',
};

export interface RoleDescriptionsModalProps {
    /** The roles that can be assigned to users of this Client, in display order. Only these roles are described. */
    availableRoles: Role[];
    hideModal: () => void;
}

export const RoleDescriptionsModal = (props: RoleDescriptionsModalProps) => {
    return (
        <Modal open header="Role Descriptions">
            {props.availableRoles.map((role) => (
                <Text key={role}>{`${role.toUpperCase()}: ${ROLE_DESCRIPTIONS[role]}`}</Text>
            ))}
            <div className={'modalFormButtonContainer'}>
                <Button variant="primary" onClick={() => props.hideModal()} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
